document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname.includes('/collections/')) {
      const listFaq = document.querySelectorAll(".rb-faq-question");
      listFaq.forEach((question)=>{
        const text = question.textContent.trim()
        if (!text) {
            question.remove(); // Supprime l'élément s'il est vide
        };
      });
      if (document.querySelectorAll(".rb-faq-question").length==0){
        document.querySelector(".rb-faq-shopify-section").remove();
      }

    //AFICHER PLUS TEXTE HAUT DE PAGE COLLECTION MOBILE//
    const section = document.querySelector('.custom-content-template--23316353319248__custom_content_PUiHgC');
    section.classList.add('fermer');
    
    function toggleButton() {
      let afficherPlus = section.querySelector(".afficher-plus");
    
      if (window.innerWidth < 768) {
        if (!afficherPlus) {
          afficherPlus = document.createElement("span");
          afficherPlus.classList.add("afficher-plus");
          afficherPlus.textContent = "Lire plus";
          section.appendChild(afficherPlus);
    
          afficherPlus.addEventListener("click", function () {
            section.classList.toggle("fermer");
    
            // Mise à jour immédiate du texte du bouton
            if (section.classList.contains("fermer")) {
              afficherPlus.textContent = "Lire plus";
            } else {
              afficherPlus.textContent = "Lire moins";
            }
          });
        }
      } else {
        if (afficherPlus) {
          afficherPlus.remove();
          section.classList.remove("fermer"); // Réinitialiser l'affichage en desktop
        }
      }
    }
    
    // Exécuter au chargement et surveiller les changements de taille d'écran
    toggleButton();
    window.addEventListener("resize", toggleButton);

    toggleButton(); // Exécuter au chargement
    window.addEventListener("resize", toggleButton); // Vérifier au redimensionnement
    };


  //PANIER SCROLL
  const drawer = document.querySelector(".drawer");

  const toggleScroll = () => {
      if (drawer.classList.contains("active")) {
          document.body.classList.add("no-scroll")
      } else {
          document.body.classList.remove("no-scroll")
      }
  };
  
  // Observer les changements de classe
  const observer = new MutationObserver(toggleScroll);
  observer.observe(drawer, { attributes: true, attributeFilter: ["class"] });
  
  // Vérification initiale au chargement
  toggleScroll();

});